import { useEffect } from 'react';
import SlotCounter from 'react-slot-counter';
import { MDText } from 'i18n-react';

import { ProgressBar } from '@motorway/mw-highway-code/pre-alpha';

import { triggerBulkBiddingModalOpened } from 'Services/analytics/events/bulkBiddingEvents/triggerBulkBiddingModalOpened';

import bulkBiddingModalTexts from '../../BulkBidding.texts';
import { Description } from '../Description/Description';
import { BULK_BIDDING_VIEW_NAMES } from '../useBulkBiddingModalViewName';

import { ProcessingDatagridSkeleton } from './ProcessingDatagridSkeleton';

import styles from './ProcessingBidsView.module.scss';

const LocalT = new MDText(bulkBiddingModalTexts.processingView);

interface ProcessingBidsViewProps {
	bidsProcessedCount: number;
	totalBidsCount: number;
}

export const ProcessingBidsView: React.FC<ProcessingBidsViewProps> = ({ bidsProcessedCount, totalBidsCount }) => {
	useEffect(() => {
		triggerBulkBiddingModalOpened(BULK_BIDDING_VIEW_NAMES.PROCESSING);
	}, []);

	return (
		<div className={styles.container}>
			<Description heading={LocalT.translate('heading')} infoText={LocalT.translate('info')} />
			<div className={styles.processedBidsContainer}>
				<span className={styles.processedBidsText}>
					{LocalT.translate('processedBids.progress', {
						processed: (
							<SlotCounter
								autoAnimationStart={false}
								duration={0.3}
								sequentialAnimationMode={true}
								value={bidsProcessedCount}
							/>
						),
						total: totalBidsCount,
					})}
				</span>
				<ProgressBar
					aria-label={`${LocalT.translate('processedBids.ariaLabel')}`}
					currentValue={bidsProcessedCount}
					maxValue={totalBidsCount}
				/>
			</div>
			<div className={styles.skeletonContainer}>
				<ProcessingDatagridSkeleton />
			</div>
		</div>
	);
};
